<script setup>
import { ref, computed, TransitionGroup } from "vue";

const props = defineProps({
  steps: { type: Array, required: true }, // [{ key: 'plan', label: 'Plan' }, ...]
});
const emit = defineEmits(["finish", "step-change"]);

const step = ref(0);
const isFirst = computed(() => step.value === 0);
const isLast = computed(() => step.value === props.steps.length - 1);

function go(idx) {
  if (idx < 0 || idx > props.steps.length - 1) return;
  step.value = idx;
  emit("step-change", step.value);
  // Scroll to top of stepper on step change
  window.scrollTo({ top: 0, behavior: "smooth" });
}
function next() {
  if (isLast.value) {
    emit("finish");
  } else go(step.value + 1);
}
function prev() {
  if (!isFirst.value) go(step.value - 1);
}
</script>

<template>
  <div>
    <div class="grid gap-6 md:grid-cols-12">
      <!-- LEFT: vertical nav DESKTOP ONLY -->
      <aside class="md:col-span-3 hidden md:block">
        <nav aria-label="Kroki" class="mb-6">
          <ol class="space-y-2">
            <li v-for="(s, idx) in steps" :key="s.key">
              <button
                type="button"
                class="w-full truncate rounded-lg border px-3 py-2 text-left text-sm transition cursor-pointer"
                :class="
                  idx === step
                    ? 'bg-slate-900 text-white border-slate-900'
                    : 'bg-white text-slate-700 border-slate-300 hover:bg-slate-50'
                "
                :aria-current="idx === step ? 'step' : undefined"
                @click="go(idx)"
              >
                <span class="inline-flex items-center gap-2">
                  <span
                    class="grid size-6 place-items-center rounded-full border text-xs"
                    :class="
                      idx <= step
                        ? 'bg-white text-slate-900 border-slate-900'
                        : 'bg-white text-slate-600 border-slate-300'
                    "
                  >
                    {{ idx + 1 }}
                  </span>
                  <span class="truncate">{{ s.label }}</span>
                </span>
              </button>
            </li>
          </ol>
        </nav>
      </aside>

      <!-- RIGHT: step content + controls -->
      <main class="md:col-span-9">
        <TransitionGroup
          tag="div"
          class="relative px-4 md:px-0"
          enter-active-class="transition-opacity duration-300"
          leave-active-class="transition-opacity duration-300 absolute inset-0"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div v-for="(s, idx) in steps" :key="s.key" v-show="step === idx">
            <slot :name="s.key" />
          </div>
        </TransitionGroup>

        <!-- Next / Prev -->
        <div
          class="flex items-center justify-between md:col-span-9 mt-4 bg-white md:bg-transparent fixed md:static w-full bottom-0 py-3 px-4 md:px-0 border-t md:border-0 border-gray-200"
        >
          <button
            type="button"
            class="rounded-lg border border-slate-300 px-3 py-2 text-lg text-slate-700 hover:bg-slate-50 disabled:opacity-50 cursor-pointer"
            :disabled="isFirst"
            @click="prev"
          >
            Wstecz
          </button>
          <button
            type="button"
            class="rounded-lg bg-slate-900 px-4 py-2 text-lg text-white hover:bg-slate-800 cursor-pointer"
            @click="next"
            v-if="!isLast"
          >
            Dalej
          </button>
        </div>
      </main>
    </div>
  </div>
</template>
